import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import BedSvg from '../../../shared/UI/bedSvg';
import { replaceDashSpace, pluralHelper } from '../../../../helpers/stringutils';

dayjs.extend(AdvancedFormat);


class ExtendCard extends PureComponent {

    constructor(props){
        super(props);
        this.extendDay = this.extendDay.bind(this);
    }

    extendDay(e){
        e.preventDefault();
        this.props.onExtendClicked();
    }

    render(){

        const { itinerary, index, builderData:{nights}, share } = this.props;
  
        const _previousCity = itinerary[index-1].to;
        const _previousEndDate = dayjs(itinerary[index-1].date).add(itinerary[index-1].nights, 'days');
        const _extendDate = _previousEndDate.add(nights, 'days').format("Do MMMM");
        const _nextCity = itinerary[index+1].to;
        const _nextDate = dayjs(itinerary[index+1].date).format("Do MMMM");
        const _nextType = itinerary[index+1].type;
        const _gapType = itinerary[index].message;
        const _nextProductName = itinerary[index+1].name;
        const _dateDiff = dayjs(itinerary[index+1].date).diff(dayjs(_previousEndDate), 'days');


        return (
            <div className={`panel small-panel extends no-border flex ${_gapType.toLowerCase()}`}>
                <div className="clearfix flex items-center col-12">

                    {
                        !share && (
                            <>
                            <div className="flex col col-8">
                                <p className="extends orange-text">   
                                    {
                                        _nextType !== "product" ?
                                    <><span className="bold">Notice: Next coach departure to {_nextCity} is after {_dateDiff} {pluralHelper('day', _dateDiff)}.</span><br /></> :
                                        <><span className="bold">Notice: {replaceDashSpace(_nextProductName)} starts after {_dateDiff} {pluralHelper('day', _dateDiff)}.</span><br /></>
                                    }  
                                    Hit the extend button to stay in {_previousCity}  until {_extendDate}.
                                </p>
                            </div>

                            <div className="flex col col-4 justify-end items-center">
                                <button className="extends-btn mr4 bold" onClick={this.extendDay}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="16" className="mr1">
                                        <path fill="currentColor" d="M320 332v8c0 6.6-5.4 12-12 12h-68v68c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-68h-68c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h68v-68c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v68h68c6.6 0 12 5.4 12 12zm128-220v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v52h192V12c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-416 0v48h384v-48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm384 352V192H32v272c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16z"/>
                                    </svg>    
                                <div className="inline-block">Extend</div> 
                                </button>
                            </div>
                            </>
                        )
                    }

                    {
                        share &&
                            <div className="flex justify-center col-12">
                                <p className="extends agent-portal-grey">
                                    <BedSvg fill="#808080" clazz="mr2 xs-hide" height="24" width="24" />
                                    <span className="bold">Find a place to sleep! </span> Your next departure to {_nextCity} is on {_nextDate}
                                </p>      
                            </div>
                    }
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return{
        itinerary:state.currentBooking.itinerary
    }
}

export default connect(mapStateToProps, null)(ExtendCard);